module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens10-d9918bfc576f786cca04c961e01b6e09.jpg";